var ToggleEvents;
(function (ToggleEvents) {
    ToggleEvents["ON"] = "toggle:on";
    ToggleEvents["OFF"] = "toggle:off";
    ToggleEvents["MIXED"] = "toggle:mixed";
    ToggleEvents["ENABLED"] = "toggle:enabled";
    ToggleEvents["DISABLED"] = "toggle:disabled";
    ToggleEvents["READONLY"] = "toggle:readonly";
})(ToggleEvents || (ToggleEvents = {}));
export default ToggleEvents;
